import { Tag } from "common/components/Tag"
import { Video } from "lucide-react"
import { useTranslations } from "modules/i18n/hooks/useTranslations"

export const VideoTag = () => {
  const t = useTranslations("components.content_summary_tag")
  return <Tag icon={<Video className="size-3.5" />}>{t("watch")}</Tag>
}
